



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import SubmissionFormOfferDetails from "./SubmissionFormOfferDetails.vue";
import SubmissionFormOfferLineItems from "./SubmissionFormOfferLineItems.vue";
import SubmissionFormInsuranceInfo from "./SubmissionFormInsuranceInfo.vue";
import SubmissionFormContactInfo from "./SubmissionFormContactInfo.vue";
import SubmissionFormInvoiceInfo from "./SubmissionFormInvoiceInfo.vue";
import SubmissionFormStatements from "./SubmissionFormStatements.vue";
import SubmissionFormComment from "./SubmissionFormComment.vue";
import SubmissionFormAttachments from "./SubmissionFormAttachments.vue";
import SubmissionFormSubmitDialog from "./SubmissionFormSubmitDialog.vue";
import SubmissionFormWarranty from "./SubmissionFormWarranty.vue";
import Offer from "../models/Offer";
import AttachmentInfo from "../models/AttachmentInfo";
import Attachment from "../models/Attachment";
import { AttachmentTypes } from "../Constants";
import { ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import OffersAPI from "../services/OffersAPI";
import OfferContent from "../models/OfferContent";

extend("required", {
  ...required,
  message: "Pole jest wymagane"
});

@Component({
  components: {
    SubmissionFormOfferDetails,
    SubmissionFormOfferLineItems,
    SubmissionFormInsuranceInfo,
    SubmissionFormContactInfo,
    SubmissionFormInvoiceInfo,
    SubmissionFormStatements,
    SubmissionFormComment,
    SubmissionFormAttachments,
    SubmissionFormSubmitDialog,
    SubmissionFormWarranty,
    ValidationObserver
  }
})
export default class SubmissionForm extends Vue {
  @Prop() private offer!: Offer;
  @Prop() private offerId!: string;
  @Prop() private requestId!: string;
  uploading: boolean = false;
  uploadProgress: number = 0;
  attachmentsUploaded: number = 0;
  attachments: Array<Attachment> = new Array<Attachment>();
  attachmentInfos: Array<AttachmentInfo> = new Array<AttachmentInfo>();
  uploadMessage: string = "";
  submmissionSuccessful: boolean = false;
  statementsUnchecked: boolean = false;

  onInsuredChange(val: string) {
    if (val === "true") {
      if (!this.attachments.some(att => att.type === AttachmentTypes.POLISA))
        this.attachments.push(new Attachment({ type: AttachmentTypes.POLISA }));
    }
  }

  onStatementsChange(val: boolean) {
    this.statementsUnchecked = !val;
  }

  onStatementCheckChange(val: boolean) {
    this.statementsUnchecked = val;
  }

  async uploadAttachments() {
    this.attachmentsUploaded = 0;
    let currentStep = 0;
    const step = 1 / this.attachments.length;
    this.attachmentInfos = new Array<AttachmentInfo>();

    for (const att of this.attachments) {
      const uploadInfo = await OffersAPI.getUploadInfo(
        this.requestId,
        att.fileName
      );

      this.uploadMessage = `Wysyłanie pliku '${att.fileName}'...`;

      await OffersAPI.uploadAttachment(
        uploadInfo.uploadUrl,
        att.file as File,
        progressEvent => {
          const completed = progressEvent.loaded / progressEvent.total;
          console.log(`${att.fileName} progress: ${completed}`);
          this.uploadProgress = Math.round(
            (currentStep + completed * step) * 100
          );
        }
      );

      this.attachmentInfos.push(
        new AttachmentInfo(
          uploadInfo.attachmentId,
          att.file?.name as string,
          att.description,
          att.type
        )
      );

      this.attachmentsUploaded++;
      currentStep = this.attachmentsUploaded / this.attachments.length;
    }
  }

  async postSubmission() {
    this.uploadMessage = `Wysyłanie danych oferty...`;
    const offerContent = new OfferContent(
      this.attachmentInfos,
      this.offer.contactInfo,
      this.offer.lineItems,
      this.offer.insuranceInfo,
      this.offer.invoiceInfo,
      this.offer.comment,
      this.offer.offerDetails.warrantyPeriod
    );
    await OffersAPI.postSubmission(this.offerId, this.requestId, offerContent);
  }

  async sendOffer() {
    this.uploading = true;
    this.uploadProgress = 0;

    await this.uploadAttachments();

    this.uploadProgress = 100;

    await this.postSubmission();

    this.$bvModal.hide("modal-confirmation");
    this.uploading = false;
    this.submmissionSuccessful = true;
  }

  async submitForm() {
    this.$bvModal.show("modal-confirmation");
  }
}
